import { useState } from 'react'

// local imports
import { IFilteredCoiffeurSalonList } from 'types/CoiffeurType'
import CoiffeurService from 'service/CoiffeurService'

export default function useGetCoiffeurSalonList() {
  const [coiffeurSalons, setCoiffeurSalons] = useState<IFilteredCoiffeurSalonList[] | []>([])
  const [loading, setLoading] = useState(false)

  /* Get Coiffeur Salon List */
  const getSalonList = (data: any) => {
    setLoading(true)
    CoiffeurService.getFilteredCoiffeurSalonList(data)
      .then((r) => setCoiffeurSalons(r.data))
      .finally(() => setLoading(false))
  }

  return { coiffeurSalons, getSalonList, loading }
}
